import { useQuery } from '@tanstack/react-query'
import { getCompanySpaces, getSpaces, getPermissionsAssociated } from '../services/Services'
import { getCurrentURL } from '../utils/utils'

export const useCompanySpaces = () => {
  const url = getCurrentURL()

  return useQuery({
    queryKey: ['companySpaces', url],
    queryFn: () => getCompanySpaces(url)
  })
}

export const useSpaces = () => {
  const url = getCurrentURL()

  return useQuery({
    queryKey: ['spaces'],
    queryFn: () => getSpaces(url)
  })
}

export const usePermissionsAssociated = () => {
  const url = getCurrentURL()

  return useQuery({
    queryKey: ['permissionsAssociated', url],
    queryFn: () => getPermissionsAssociated(url),
    select: (data) => ({
      hasAssociated: data?.body?.content[0]?.associated || false
    })
  })
}
